import { UploadedPhotoFile } from 'four-nets/ui-v2/form/upload-photofile/upload-photofile';

export default class PhotoFileUpload {
    static key = 0;

    key = PhotoFileUpload.key++;
    url: string;
    loading?: boolean;
    error?: Error | null;

    constructor(public file: File, public photofile?: UploadedPhotoFile) {
        this.file = file;
        this.photofile = photofile;
        this.url = URL.createObjectURL(file);
    }

    isValid = () => {
        return this.photofile && this.photofile.id;
    };

    setPhotoFile = (photofile: any) => {
        this.photofile = photofile;
        this.error = null;
        this.loading = false;
    };
}
